export default __webpack_public_path__ + "images/public/images/homeImagePager/Giba.jpg";